import { app_base_url, Signed_url,MysqlBaseUrl } from "./config_local";

const axios = require("axios");
const base_url = app_base_url

export const call = async (
  config = { method: "GET" },
  data = {},
  params = {}
) => {
  let url = base_url + config.url;

  if (config.method === "GET" && data && Object.keys(data).length > 0) {
    url += "?";
    Object.entries(data).forEach(([key, value]) => {
      url += `${key}=${value}&`;
    });
  }
  if (params && Object.keys(params).length > 0) {
    url += "?";
    Object.entries(params).forEach(([key, value]) => {
      url += `${key}=${value}&`;
    });
  }
  if (url.substr(url.length - 1, url.length) === "&") {
    url = url.slice(0, url.length - 1);
  }
  const options = {
    method: config.method,
    url,
    mode: "cors",
    redirect: "follow",
    referrerPolicy: "no-referrer",
    timeout: 60000,
    headers: {
      Authorization: localStorage.getItem("token")?.replace(/\"/g, ""),
    },
  };
  if (["POST", "PUT", "DELETE"].indexOf(config.method) > -1) {
    // options.data = JSON.stringify(data);
    options.data = data;
  }
  return axios(options);
};


export const Signed = async (
  config = { method: "GET" },
  data = {},
  params = {}
) => {
  let url = Signed_url + config.url;

  if (config.method === "GET" && data && Object.keys(data).length > 0) {
    url += "?";
    Object.entries(data).forEach(([key, value]) => {
      url += `${key}=${value}&`;
    });
  }
  if (params && Object.keys(params).length > 0) {
    url += "?";
    Object.entries(params).forEach(([key, value]) => {
      url += `${key}=${value}&`;
    });
  }
  if (url.substr(url.length - 1, url.length) === "&") {
    url = url.slice(0, url.length - 1);
  }
  const options = {
    method: config.method,
    url,
    mode: "cors",
    redirect: "follow",
    referrerPolicy: "no-referrer",
    timeout: 60000,
    headers: {
      Authorization: localStorage.getItem("token")?.replace(/\"/g, ""),
    },
  };
  if (["POST", "PUT", "DELETE"].indexOf(config.method) > -1) {
    // options.data = JSON.stringify(data);
    options.data = data;
  }
  return axios(options);
};



export const axiosInstance = axios.create({
  baseURL: MysqlBaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});


axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    config.headers.Authorization = token ? `Bearer ${token}` : '';
    return config;
  },
  (error) => Promise.reject(error)
);



axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true; 

      try {
        const { username, password } = getCredentials(); 
        const loginResponse = await login(username, password);

        const newToken = loginResponse.data.token;
        localStorage.setItem('token', newToken);

        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return axiosInstance(originalRequest);
      } catch (loginError) {
        console.error('Re-authentication failed:', loginError);
        return Promise.reject(loginError);
      }
    }

    return Promise.reject(error);
  }
);

export const login = async (username, password) => {
  try {
    const response = await axiosInstance.post('Auth/login', {
      username,
      password,
    });
    
    const token = response.data.token;
    localStorage.setItem('token', token);
    return response;
  } catch (error) {
    console.error('Login failed:', error.response?.data || error.message);
    throw error;
  }
};

const getCredentials = () => {
  return {
    username: 'system_admin', 
    password: 'ABKLFIN202400018', 
  };
};